import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Logo from "../../assets/images/header/SIA Logo.png";
import NewiconA from "../../assets/images/contact/redrightarrow.png";
import Image from "next/image";
import Link from "next/link";
import { hallticketApiservice } from "../../components/Service/hallticketdownload"; 
import { useState, useRef } from 'react';

import Head from "next/head";

export default function HallTicketPage() {
  const [RegMobile, setRegMobile] = useState('');
  const [submittedData, setSubmittedData] = useState(null);
  const pdfRef = useRef();
    // Example submit handler with enhanced debugging & error handling
  async function downloapdfsubmit(e)
  {
    e.preventDefault();
    const mobile={RegMobile}; 
  console.log(mobile);   
  
  hallticketApiservice(mobile)
  .then((response) => {
    console.log("API Response:", response);
    console.log("API Response:", response.value);
    if(response.success===false)
    {
      alert(response.message);
      //document.getElementById("mobileNumber").reset();
    }
    else{
      setSubmittedData(response.value)
    }
   
  });
  console.log(mobile);
      //setSubmittedData(); 
  }

      // Handle PDF generation using html2canvas and jsPDF
  const generatePDF = async () => {
    if (typeof window === "undefined") return; // ensures we're in the browser
  
    const html2pdf = (await import("html2pdf.js")).default;
    const input = pdfRef.current;
    const opt = {
      margin: 10,
      filename: "siahallticket.pdf",
      image: { type: "jpeg", quality: 0.50 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
    };
  
    html2pdf().set(opt).from(input).save().catch((error) => {
      console.error("Error generating PDF:", error);
    });
  };
  

  return (
    <>
    <Head>
        <meta name="robots" content="noindex,nofollow" />
        <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
        <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
        <title>TNPSC Group II/IIA Mains State Level Mock Test 2026  </title>
    </Head>

    <Navbar title="home" />

    <h4 className="pt-5 pb-4 text-center" style={{ fontFamily: "Switzer-Bold" ,fontsqize:"20px"}}>
      I'M TOP TNPSC Group II/IIA Mains State Level Mock Test 2026 
    </h4>

    <div className="container p-4" style={{ backgroundColor: "#fff8ea" }}>   
        {/* Form to submit Mobile Number */}
        <form onSubmit={downloapdfsubmit} className="mobile-label mb-4 col-md-6 mx-auto">
          <label htmlFor="mobileNumber" style={{ fontSize: "15px", textAlign: "justify" }}>Enter your Reg Mobile No / Tnpsc Grp II&IIA Prelims Reg No :</label>
          <input
            type="tel"
            name="mobileNumber"
            id="mobileNumber"
            required
            value={RegMobile}
            onChange={(e) => setRegMobile(e.target.value)}
            className="form-control mobile-input"
          />
          <button type="submit" className="btn btn-primary mt-3">
            Submit
          </button>
        </form>

    <div className="col-md-6 mx-auto">
        {/* <Link  href="/tnpsc-group-II-IIA-mains-mock-test" target="_blank" rel="noopener noreferrer">
            <span className="mobile-label mb-4 col-md-6 mx-auto" style={{ color: "#db1913ff", fontSize: "19px",  }}> Instructions <Image src={NewiconA} alt="download icon"/></span>
        </Link> */}
    </div>

      <div className="row pt-2">
        <div className="mb-4 col-md-6 mx-auto" style={{ fontSize: "14px", textAlign: "justify" }}>
          <p><span className=" mb-4 col-md-6" style={{ color: "#db1913ff", fontSize: "18px",  }}>Instructions to Offline students :</span> </p>
          <p>Dear Offline Students, Kindly bring the Hard copy of <br/> GR IIA Mains and Shankar Hall Ticket without Fail</p>
        <p className=" mb-4 col-md-6"> <b>Enquiry : +91 9360816977</b></p>
        </div>

        <div className="mb-4 col-md-6 mx-auto" style={{ fontSize: "14px", textAlign: "justify" }}>
         <p><span className=" mb-4 col-md-6" style={{ color: "#db1913ff", fontSize: "18px",  }}>Instructions to online students only :</span> </p>
         <p>We have arranged a Demo Test (For Trial which consists of 25 Qns) for Online Mode Registration of GR IIA MAINS STATE LEVEL MOCK TEST in the Shankar IAS Academy’s Test Press Portal:</p>
         <p><span className=" mb-4 col-md-6" style={{ color: "#db1913ff", fontSize: "14px",  }}> NON SHANKAR STUDENTS : </span> can access the demo test</p>
       
         <p><b>Test Press Portal : </b><a href="https://shankariastnpsctestbatch.testpress.in/" target="_blank" rel="noopener noreferrer" >https://shankariastnpsctestbatch.testpress.in/</a></p>
         <p><b>Username : </b>Your Mobile No</p>
         <p><b>Password : </b>Your Mobile No</p>
         <p><span className=" mb-4 col-md-6" style={{ color: "#db1913ff", fontSize: "14px",  }}> SHANKAR STUDENTS : </span> Use your SIAAN ID Provided in the Institute.</p>
        </div>
      </div>
    </div>

    { submittedData && (
    <div className="container mt-4 pt-3">
      <button type="button" onClick={generatePDF} className="download-button">
        Download Hall Ticket
      </button>
      <div className="col-12">
        <div ref={pdfRef} className="mt-2 p-2 border rounded-lg bg-gray-600">
          <div className="row">             
            <div className="col-4 ">
              <table className="table">
              </table>
            </div>
            <div className=" d-flex justify-content-center align-items-center ">
              <Image
                src={Logo}
                alt="shankar ias logo"
                title="Shankar IAS Academy"
                className="img-fluid"
                style={{ width: '220px', height: 'auto' }}
              />
            </div>
          </div>
        
          <div className="row">
            <div className="col-12 align-items-center ">
              <div>
                <h5 className="text-center pt-2" style={{ fontFamily: "Switzer-Bold" ,fontSize:"15px" }}>
                  TNPSC Group II/IIA Mains State Level Mock Test 2026  
                </h5>
                <h5 className="text-center" style={{ fontFamily: "Switzer-Bold",fontSize:"15px" }}>
                  Hall Ticket
                </h5> 
              </div>
            </div>
          </div>
    
          <div className="formsection">
            <div className="fields">
              <table className="table">
                <thead>
                  <tr>
                    <th>Required Field</th>
                    <th>Candidate Details</th>
                    <th>Candidate’s Photo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ fontFamily: "Switzer-Bold"}}>Name of the Candidate:</td>
                    <td>
                      <span className="input-field">{submittedData.name}</span>
                    </td>
                    <td rowSpan="7" className="photo">
                      <img src={submittedData.candidatePhoto ? submittedData.candidatePhoto : "/no-image.png"}
                        alt="Uploaded"
                        className="mt-2 object-cover border rounded"
                        style={{ width: "150px", height: "150px" }}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td style={{ fontFamily: "Switzer-Bold"}}>Tnpsc Grp II&IIA  Prelims Reg. No:</td>
                    <td>
                      <span className="input-field">{submittedData.grIIreg}</span>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ fontFamily: "Switzer-Bold"}}>Mobile No:</td>
                    <td>
                      <span className="input-field">{submittedData.mobileNo}</span>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ fontFamily: "Switzer-Bold"}}>Date of Birth:</td>
                    <td>
                      <span className="input-field">{submittedData.dateofbirth}</span>
                    </td>
                  </tr>

                   <tr>
                    <td style={{ fontFamily: "Switzer-Bold"}}>Mock Test <br/>Applied For:</td>
                    <td>
                      <span className="input-field">{submittedData.mocktestapplied}</span>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ fontFamily: "Switzer-Bold"}}>Centre Name:</td>
                    <td>
                      <span className="input-field">{submittedData.centerName}</span>
                    </td>
                  </tr>


                  <tr>
                    <td style={{ fontFamily: "Switzer-Bold"}}>Venue:</td>
                    <td>
                      <span className="input-field">{submittedData.venue ? submittedData.venue :"Update Soon" }</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <h6 className="pt-1" style={{ fontFamily: "Switzer-Bold" , fontSize:"12px" }}>
            TNPSC GROUP II & IIA MOCK TEST DATE AND TIME
          </h6>

          <div className="formsection">
            <div className="fields">
              <table className="table">
                <thead>
                  <tr className="text-center">
                    <th>DATE</th>
                    <th>PAPER</th>
                    <th>TIME</th>
                    <th>STUDENT SIGN</th>
                    <th>INVIGILATOR SIGN</th>
                  </tr>
                </thead>
                <tbody>  
                  <tr className="text-center">
                    <td>1st Feb</td>
                    <td><b>GRP IIA</b> - General Studies <br/>Paper II (OMR Based)</td>
                    <td> <span className="input-field">09:30 AM TO 12:30 PM</span></td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr className="text-center">
                    <td>1st Feb</td>
                    <td>Tamil Eligibility<br/>Paper I (Descriptive) <br/> <b> Note: Common For Both II&IIA</b></td>
                    <td className="pt-4"><span className="input-field ">02:00 PM TO 05:00 PM</span></td>
                    <td></td>
                    <td></td>
                  </tr>

                   <tr className="text-center">
                    <td>15th Feb</td>
                    <td><b>GRP II</b> - Paper-II (General Studies) - Descriptive</td>
                    <td><span className="input-field">09:30 AM TO 12:30 PM</span></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <h6 className=" pt-2 pb-2" style={{ fontFamily: "Switzer-Bold" , fontSize:"13px" }}>
              Note : GRP IIA MAINS (OMR Based)
          </h6>
          <p style={{ fontSize:"12px" , textAlign:"justify" }}> <b>1. For Offline Students:</b> </p>
          <p style={{ fontSize:"12px" , textAlign:"justify" }}>
            All the mock registered candidates need to bring SIA Mock Test Hall Ticket (Hard Copy) and TNPSC Group II or Group IIA Prelims or Mains Hall Ticket 2025(Hard Copy) and submit them at the respective exam venue. After due verification of your hall tickets, you will be allowed to enter the exam venue. 
          </p>
          <p style={{ fontSize:"12px" , textAlign:"justify" }}> <b>2. For Online Students:</b> </p> 
          <p style={{ fontSize:"12px" , textAlign:"justify" }}>
            Students need to take up their Test in the TEST PRESS PORTAL : <b> https://shankariastnpsctestbatch.testpress.in/</b> .
          </p>

          <h6 className=" pt-2 pb-2" style={{ fontFamily: "Switzer-Bold" , fontSize:"13px" }}>
              Note: GRP II MAINS (Descriptive)
          </h6>

          <p style={{ fontSize:"12px" , textAlign:"justify" }}> <b>1. For Offline Students:</b> </p>
          <p style={{ fontSize:"12px" , textAlign:"justify" }}>
            All the mock registered candidates need to bring SIA Mock Test Hall Ticket (Hard Copy) and TNPSC Group II or Group IIA Prelims or Mains Hall Ticket 2025(Hard Copy) and submit them at the respective exam venue. After due verification of your hall tickets, you will be allowed to enter the exam venue.
          </p>
          <p style={{ fontSize:"12px" , textAlign:"justify" }}> <b>2. For Online Students:</b> </p> 
          <p style={{ fontSize:"12px" , textAlign:"justify" }}>
            All the online candidates need to attach this hall-ticket and TNPSC Group II&IIA Prelims/Mains 2025 Hall-Ticket along with their Scanned Copy of the Written Answer booklet and share it to <b>tnpscmains@shankarias.in</b> on the day of test before 4:00 PM without fail.
          </p>

          <p style={{ fontSize:"12px" , textAlign:"center" }}> There will be <b>No Evaluation </b>for Tamil Eligibility Tests (Paper – 1)</p>

        </div>
      </div>
    </div>        
    )}

    {/* Scoped CSS using JSX */}
    <style jsx>{`
        .container {
          width: 100%;
          max-width: 900px;
          margin: 0 auto;
          background-color: white;
          padding: 20px;
          border-radius: 10px;
          box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
        }
        .formsection {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 1rem;
        }
        .fields {
          width: 100%;
        }
        .table {
          width: 100%;
          border-collapse: collapse;
        }
        .table td {
          border: 1px solid #00000069;
          padding: 0.5rem;
          background-color: #ffffff;
          color: #161414;
          font-size: 12px;
        }
        th {
          font-family: "Switzer-Bold";
          border: 1px solid #00000069;
          padding: 0.5rem;
          background-color: #f2f2f2;
          font-size: 12px;
        }
        .input-field {
          font-family: Switzer-Medium;
        }
        .photo {
          text-align: center;
        }
        .download-button {
          background-color: red;
          color: white;
          padding: 0.5rem 1rem;
          border: none;
          border-radius: 0.25rem;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }
        .download-button:hover {
          background-color: darkred;
        }

         .mobile-label {
          display: block;
          font-size: 14px;
           margin:10px;
       }
        .mobile-input {
        
          font-size: 14px;
          border: 1px solid #ccc;
          border-radius: 4px;
          width: 100%;
          box-sizing: border-box;
              margin: 10px 0px;
        }

          /* Mobile-specific styles */

        @media (max-width: 600px) {
          .container {
            padding: 10px;
            margin: 0 10px;
          }
          .formsection {
            flex-direction: column;
          }
          .table td,
          th {
            font-size: 14px;
            padding: 0.3rem;
          }
          .download-button {
            padding: 0.4rem 0.8rem;
            font-size: 14px;
          }
        }
    `}</style>

    <Footer />
    </>
  );
}
